/**
 * ExtraSearch JS controller.
 */

// Use jQuery as $ within this file scope.
const $ = jQuery;

/**
 * Class ExtraSearch
 */
class ExtraSearch {

    /**
     * CLass constructor.
     */
    constructor() {

        // Loading state for preventing simultaneous searches.
        this.loading = false;

        // Current option value.
        this.option = '';

        this.limit = null;

        // Current search container.
        this.$currentSearch = null;

        // Create spinner dynamically in JavaScript, so we can throw it easily back and forth.
        this.$spinner = $( '<i>', { 'class': 'fas fa-spin fa-spinner-third' });

        // Create overlay dynamically in JavaScript.
        this.$overlay = $( '<div />', {
            'id': 'js-extra-search-overlay',
            'class': 'extra-search__overlay'
        });
    }

    /**
     * Cache dom elements for use in the class's methods
     */
    cache() {
        this.$container      = $( '.js-extra-search' );
        this.$input          = $( '.js-extra-search-input' );
        this.$btn            = $( '.js-extra-search-btn' );
        this.$resultsWrapper = $( '.js-extra-search-results-wrapper' );
        this.$results        = $( '.js-extra-search-results' );
    }

    /**
     * Common events.
     */
    events() {
        $( window ).on( 'mousedown touchend', ( e ) => {
            this.handleClickOutside( e );
        });

        // Prepare search on search button click.
        this.$btn.on( 'click', ( e ) => {
            this.prepareSearch( e );
        });

        // Prepare search on enter key press.
        this.$input.on( 'keyup', ( e ) => {
            if ( e.key == 'Enter' ) {
                this.prepareSearch( e );
            }
        });

        // Close results when pressing escape key.
        $( document ).on( 'keyup', ( e ) => {
            if ( ! this.loading && ( e.key === 'Escape' ) || e.key == 'Esc' ) {
                this.$resultsWrapper.hide();
                this.toggleOverlay( false );
            }
        });
    }

    /**
     * Handle results hiding when clicking outside.
     *
     * @param {object} e Event object.
     */
    handleClickOutside( e ) {
        if (
            ! this.loading &&
            ! $( e.target ).closest( this.$results ).length &&
            ! $( e.target ).is( this.$btn )
        ) {
            this.$resultsWrapper.hide();
            this.toggleOverlay( false );
        }
    }

    /**
     * Prepare search and make the actual search.
     *
     * @param {object} e Event object.
     */
    prepareSearch( e ) {

        // Get the current search.
        this.$currentSearch = $( e.target ).closest( this.$container );

        // Get the current input.
        const $input = $( this.$currentSearch.find( this.$input ) );

        // Prevent multiple simultaneous searches and empty searches.
        if ( ! this.loading && $input.val() ) {

            // Update option and limit values.
            this.option = this.$currentSearch.data( 'option' );
            this.limit = this.$currentSearch.data( 'limit' );

            // Make the search.
            this.search( $input.val() );
        }

        this.toggleOverlay( true );
    }

    /**
     * Make the search!
     *
     * @param {string} address Address.
     */
    search( address ) {

        // Toggle loading state.
        this.toggleLoading( true );

        // Make the ajax request.
        dp( 'ExtraSearch', {
            tidy: true,
            bypassMainQuery: false,
            args: {
                option: this.option,
                limit: this.limit,
                address: address
            },
            data: true,
            partial: 'extra-search-results'
        }).then( data => {
            this.handleSuccess( data.success );
        }).catch( error => {
            this.handleError( error );
        });
    }

    /**
     * Handle successful request.
     *
     * @param {string} data Successful request data.
     */
    handleSuccess( data ) {
        this.data = data;

        // If container is small, add mobile class for mobile styling.
        if ( this.$container.width() < 640 ) {
            this.$results.addClass( 'extra-search__results--mobile' );
        } else {
            this.$results.removeClass( 'extra-search__results--mobile' );
        }

        // Append data into DOM.
        this.$currentSearch.find( this.$results ).html( data );

        // Change focus to results wrapper.
        this.$resultsWrapper.focus();

        // Toggle loading state to false.
        this.toggleLoading( false );
    }

    /**
     *  Handle failed request.
     *
     * @param {mixed} error Failed request error data.
     */
    handleError( error ) {
        this.toggleLoading( false );
        console.error( error );
    }

    /**
     * Toggles loading and handles form.
     *
     * @param {bool} loading Loading state.
     */
    toggleLoading( loading ) {
        if ( loading ) {
            this.$currentSearch.find( this.$resultsWrapper ).show();
            this.$currentSearch.find( this.$results ).html( this.$spinner );
            this.loading = true;
        } else {
            this.loading = false;
        }
    }

    toggleOverlay( state ) {
        if ( state ) {
            $( 'body' ).append( this.$overlay );
        } else {
            this.$overlay.remove();
        }
    }

    /**
     * Run when the document is ready.
     */
    docReady() {
        this.cache();
        this.events();
    }
}

// Export the class reference.
module.exports = ExtraSearch;



// WEBPACK FOOTER //
// ./assets/scripts/extra-search.js